export default __webpack_public_path__ + "static/media/es-imone-img.b6b254c0.webp";